import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    padding: theme.spacing(1.5),
    [theme.breakpoints.up('sm')]: {
      padding: theme.spacing(3),
    },
  },
  carregando: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: theme.spacing(4),
  },
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(3),
    borderRadius: '12px',
    maxWidth: '90vw',
    width: '800px',
    maxHeight: '80vh',
    overflowY: 'auto',
    outline: 'none',
    [theme.breakpoints.down('xs')]: {
      padding: theme.spacing(2),
    },
  },
  tituloEspelho: {
    fontSize: '16px',
    fontWeight: 'bold',
    color: theme.palette.text.primary,
  },
  divider: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(2),
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: theme.spacing(1),
    marginBottom: theme.spacing(2),
    [theme.breakpoints.down('xs')]: {
      flexDirection: 'column',
      width: '100%',
      '& button': {
        width: '100%',
        marginRight: '0 !important',
      },
    },
  },
  
  // Mobile Card Styles
  cardMobile: {
    marginBottom: theme.spacing(2),
    borderRadius: '12px',
    boxShadow: theme.shadows[1],
    backgroundColor: theme.palette.background.paper,
    border: `1px solid ${theme.palette.divider}`,
    overflow: 'hidden',
  },
  cardMobileHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: theme.spacing(1.5, 2),
    backgroundColor: theme.palette.action.hover,
    borderBottom: `1px solid ${theme.palette.divider}`,
  },
  cardMobileTitle: {
    fontWeight: 'bold',
    fontSize: '14px',
    color: theme.palette.text.primary,
  },
  cardMobileContent: {
    padding: theme.spacing(2),
  },
  cardMobileGrid: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: theme.spacing(1.5),
    marginBottom: theme.spacing(1.5),
  },
  cardMobileItem: {
    display: 'flex',
    flexDirection: 'column',
  },
  cardMobileLabel: {
    fontSize: '11px',
    fontWeight: 'bold',
    color: theme.palette.text.secondary,
    textTransform: 'uppercase',
    marginBottom: theme.spacing(0.5),
  },
  cardMobileValue: {
    fontSize: '13px',
    color: theme.palette.text.primary,
  },
  cardMobileActions: {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: theme.spacing(0.5),
    paddingTop: theme.spacing(1.5),
    borderTop: `1px solid ${theme.palette.divider}`,
  },
}))

export default useStyles
